import {
  ChevronRightIcon_default
} from "./chunk-VQTFNCIJ.mjs";
export {
  ChevronRightIcon_default as default
};
